// extracted by mini-css-extract-plugin
module.exports = {"Glow":"glow_Glow__XGfqc","Light":"glow_Light__xxydg"};